import {BaseService} from './Core/BaseService';

class SurveyService extends BaseService {
    get Url() { return super.Url + "/surveys"; }

    GetSurvey(surveyId) {
        return this.SendRequest(BaseService.GET, surveyId);
    }
    
    GetSurveysByConservationActionId(surveyTypeId = null, conservationActionId = null) {
        return this.SendRequest(BaseService.GET, {
            surveyTypeId,
            conservationActionId
        });
    }

    GetPublishedSurveyTypeCodesByConservationActionId(conservationActionId = null) {
        return this.SendRequest(BaseService.POST, {
            conservationActionId
        }, null, '/published');
    }

    GetSurveys(surveyTypeId = null, conservationActionTypeId = null, organizationId = null) {
        let request = {};

        if(surveyTypeId) {
            request.surveyTypeId = surveyTypeId;
        }
        if(conservationActionTypeId) {
            request.conservationActionTypeId = conservationActionTypeId;
        }
        if(organizationId) {
            request.organizationId = organizationId;
        }

        return this.SendRequest(BaseService.GET, request);
    }

    UpdateSurvey(survey) {
        return this.SendRequest(BaseService.PUT, survey);
    }

    CreateSurvey(survey) {
        return this.SendRequest(BaseService.POST, survey);
    }

    DeleteSurvey(surveyId) {
        return this.SendRequest(BaseService.DELETE, surveyId);
    }
}

export const service = new SurveyService();

